const GET = async ({ locals }) => {
  if (!locals.user) return new Response(JSON.stringify({ authenticated: false }), { status: 200 });
  return new Response(JSON.stringify({ authenticated: true, user: locals.user }));
};
export {
  GET
};
